import { createTheme } from '@mui/material/styles';

export const GREEN_BP = '#3C5537';
export const GREEN_DARK = '#222B27';
export const GREEN_LIGHT = '#B0BAB0';
export const GREEN_SUCCESS = '#4C9547';
export const CREAM = '#F9F6E4';
export const PURPLE_SURPRISE = '#7E57C2';

const header = {
  fontWeight: 600,
};

const icon = {
  colorPrimary: {
    color: GREEN_DARK,
  },
};

export default createTheme({
  palette: {
    background: {
      default: '#F4F4F4',
    },
    primary: {
      main: GREEN_BP,
    },
    secondary: {
      main: CREAM,
      contrastText: '#354847',
    },
    text: {
      primary: GREEN_DARK,
    },
    error: {
      main: '#BB0000',
    },
    success: {
      main: GREEN_SUCCESS,
    },
  },
  components: {
    MuiIconButton: { styleOverrides: icon },
    MuiSvgIcon: { styleOverrides: icon },
  },
  typography: {
    fontFamily: 'Open Sans',
    h1: header,
    h2: header,
    h3: header,
    h4: header,
    h5: header,
    h6: header,
    button: {
      fontWeight: 600,
    },
  },
});
